module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.eb43b4c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard/assest/font/roboto/Roboto-Bold.woff
// module id = zKtW
// module chunks = 0